import { AxiosRequest } from "../common/axios-request";
import {
  CREATE_COACH,
  DELETE_COACH,
  DELETE_COACH_RULE,
  GET_ALL_COACH_LIST,
  GET_COACH_DETAILS,
  UPDATE_COACH,
} from "../common/constant";

const GetCoachesList = () => {
  return AxiosRequest.get(GET_ALL_COACH_LIST);
};

const CreateNewCoach = (payload: any) => {
  return AxiosRequest.post(CREATE_COACH, payload);
};

const GetCoachesDetails = (id: string) => {
  return AxiosRequest.get(GET_COACH_DETAILS.replace(":id", id));
};

const UpdateCoach = (id: string, payload: any) => {
  return AxiosRequest.put(UPDATE_COACH.replace(":id", id), payload);
};

const DeleteCoach = (id: string) => {
  return AxiosRequest.delete(DELETE_COACH.replace(":id", id));
};

const DeleteCoachRule = (id: string, rule: string) => {
  return AxiosRequest.delete(
    DELETE_COACH_RULE.replace(":id", id).replace(":rule", rule)
  );
};

export {
  GetCoachesList,
  CreateNewCoach,
  GetCoachesDetails,
  UpdateCoach,
  DeleteCoach,
  DeleteCoachRule,
};
